<template>
  <div style="min-height: 100px" v-loading="loading">
    <div v-if="orderInfo">
      <el-card shadow="hover">
        <div style="padding: 10px">
          <warehouse-order-info :orderInfo="orderInfo">
            <template slot="append">
              <x-upload
                type="image"
                imageAlign="start"
                v-if="!!orderInfo.riderPickingPhoto"
                :fileCount="4"
                :fileSize="10 * 1024"
                :imageViewWidth="180"
                :imageViewHeight="180"
                :disabled="true"
                :value="orderInfo.riderPickingPhoto.split(',').join('|')"
              ></x-upload>
            </template>
          </warehouse-order-info>
          <div style="margin-top: 10px" v-if="orderInfo.optCancel == 0">
            <el-button v-if="orderInfo.optStatus != 1" @click="printClick" type="default">
              打印小票
            </el-button>
            <el-button
              v-if="orderInfo.orderType != 'channel'"
              @click="cancelClick"
              type="danger"
            >
              取消
            </el-button>
          </div>
        </div>
      </el-card>
      <div>
        <x-tab v-model="tabName" :tabs="tabs" :query="tabParams" :params="tabParams" />
      </div>
    </div>
    <el-empty v-else-if="!loading" :description="errorMsg" :image-size="100">
      <el-button v-if="errorMsg" @click="getDetail" size="small"> 重新加载 </el-button>
    </el-empty>
    <el-dialog
      title="提示"
      append-to-body
      :show-close="false"
      :destroy-on-close="true"
      :close-on-press-escape="false"
      :visible="printLoading"
      width="400px"
    >
      <span>
        <i class="el-icon-loading"></i>
        正在打印中
      </span>
    </el-dialog>
  </div>
</template>

<style lang="less" scoped>
.order-detail {
  margin-top: 20px;
}
</style>

<script>
import orderPayment from "./__payment.vue";
import detailOrderItemList from "./__detail_item_list.vue";
import warehouseOrderInfo from "../../../../components/business/warehouseOrderInfoByChannel.vue";
import detailInventoryListPage from "../warehouse-inventory/__inner_inventory_list.vue";
import detailPaymentListPage from "../warehouse-payment/__inner_payment_list.vue";
import detailRefundListPage from "../warehouse-payment-refund/__inner_refund_list.vue";
import detailPrescriptionPage from "./__detail_prescription.vue";

export default {
  components: {
    warehouseOrderInfo,
  },
  props: {
    params: {
      type: Object,
      default: () => {
        return {};
      },
    },
    query: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    tabParams() {
      if (!this.orderInfo) {
        return {};
      }
      return {
        guid: this.orderInfo.guid,
        bizId: "ORDER_" + this.orderInfo.guid,
        orderGuid: this.orderInfo.guid,
        storeGuid: this.orderInfo.storeGuid,
      };
    },
    tabs() {
      if (!this.orderInfo) {
        return [];
      }
      let tabList = [
        {
          name: "order-item-list",
          label: "商品&服务清单",
          component: detailOrderItemList,
          interval: true,
        },
      ];
      if (this.orderInfo.inventoryInfoCount > 0) {
        tabList.push({
          name: "order-inventory",
          label: "出入库记录",
          component: detailInventoryListPage,
          interval: true,
        });
      }
      if (this.orderInfo.paymentInfoCount > 0) {
        tabList.push({
          name: "order-payment",
          label: "收款记录",
          component: detailPaymentListPage,
          interval: true,
        });
      }
      if (this.orderInfo.paymentRefundCount > 0) {
        tabList.push({
          name: "order-refund",
          label: "退款记录",
          component: detailRefundListPage,
          interval: true,
        });
      }
      if (this.orderInfo.vetPrescriptionCount > 0 && this.orderInfo.optCancel == 0) {
        tabList.push({
          name: "order-prescription",
          label: "处方记录",
          component: detailPrescriptionPage,
          interval: true,
        });
      }
      return tabList;
    },
    pageParams() {
      return Object.assign({}, (this.$route && this.$route.params) || {}, this.params);
    },
    pageQuery() {
      return Object.assign({}, (this.$route && this.$route.query) || {}, this.query);
    },
  },
  data() {
    return {
      loading: false,
      errorMsg: null,
      orderInfo: null,
      printLoading: false,
      tabName: "",
    };
  },
  methods: {
    cancelClick() {
      if (!this.orderInfo) {
        return;
      }
      this.$confirm(`确定取消订单，此操作不可恢复，请谨慎操作?`, "提示", {
        type: "warning",
      }).then(() => {
        this.requestApi(
          "biz.warehouse.order.info.cancel",
          {
            guid: this.orderInfo.guid,
            storeGuid: this.orderInfo.storeGuid,
          },
          { showError: true }
        ).then(() => {
          this.$drawer.refreshDrawer();
          this.getDetail();
        });
      });
    },
    paymentClick() {
      if (!this.orderInfo) {
        return;
      }
      this.$drawer.openDrawer({
        title: "销售订单收款",
        refresh: this.getDetail,
        component: orderPayment,
        params: {
          guid: this.orderInfo.guid,
          storeGuid: this.orderInfo.storeGuid,
        },
      });
    },
    printClick() {
      if (!this.orderInfo) {
        return;
      }
      this.$confirm(`确定打印当前订单小票，将通过店内云小票打印设备打印小票?`, "提示", {
        type: "info",
      }).then(() => {
        this.printLoading = true;
        this.requestApi(
          "biz.warehouse.order.info.print",
          {
            guid: this.orderInfo.guid,
            storeGuid: this.orderInfo.storeGuid,
          },
          { showAlert: true }
        ).finally(() => {
          this.printLoading = false;
        });
      });
    },
    printReceiptClick() {
      if (!this.orderInfo) {
        return;
      }
      this.printOrder(this.orderInfo);
    },
    handleChangeTagLabel(value, row) {
      this.requestApi(
        "biz.warehouse.order.info.setTagLabel",
        {
          guid: row.guid,
          storeGuid: row.storeGuid,
          tagLabel: value,
        },
        { showError: true }
      ).then(() => {
        this.getDetail();
      });
    },
    getDetail() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.errorMsg = null;
      this.orderInfo = null;
      return this.requestApi("biz.warehouse.order.info.detail", {
        guid: this.pageParams.guid,
        storeGuid: this.pageParams.storeGuid,
      })
        .then((resp) => {
          this.orderInfo = resp.data;
        })
        .catch((err) => {
          this.errorMsg =
            (err && err.msg) || (err && err.message) || "连接服务器失败，请检查网络";
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.tabName = this.pageParams.tabName;
    this.getDetail();
  },
};
</script>
